import { Routes, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { authGuard } from './core/guards/auth.guard';
import { notAuthGuard } from './core/guards/not-auth.guard';
import { TranslateService } from './core/services/i18n/translate.service';

/**
 * Resolver para obtener el título de la página de login
 */
export const loginTitleResolver: ResolveFn<string> = async (route, state) => {
  const translateService = inject(TranslateService);

  // Esperar a que las traducciones estén cargadas
  await translateService.waitForTranslations();

  const appName = translateService.translate('app.name');

  return appName;
};

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/auth/auth').then((m) => m.Auth),
    canActivate: [authGuard], // Solo accesible si NO está autenticado
    title: loginTitleResolver,
  },
  {
    path: 'password-refresh',
    loadComponent: () =>
      import('./features/auth/password-refresh/password-refresh').then(
        (m) => m.PasswordRefresh
      ),
    canActivate: [notAuthGuard],
    title: loginTitleResolver,
  },
  {
    path: 'main',
    loadChildren: () => import('./features/main/main.routes').then((m) => m.mainRoutes),
    loadComponent: () => import('./features/main/main').then((m) => m.Main),
    canActivate: [notAuthGuard], // Solo accesible si está autenticado
  },
];
